import { format, parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

/**
 * Formats a date string based on the provided timezone
 */
export const formatDateTime = (dateString, timezone, formatStr = 'yyyy-MM-dd HH:mm:ss') => {
  try {
    const date = parseISO(dateString);
    return formatInTimeZone(date, timezone, formatStr);
  } catch (err) {
    console.error('Error formatting date:', err);
    return dateString;
  }
};

/**
 * Formats relative time (e.g., "2 hours ago")
 */
export const formatRelativeTime = (dateString) => {
  try {
    const date = parseISO(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffSecs = Math.floor(diffMs / 1000);
    const diffMins = Math.floor(diffSecs / 60);
    const diffHours = Math.floor(diffMins / 60);
    const diffDays = Math.floor(diffHours / 24);

    if (diffSecs < 60) {
      return `${diffSecs} seconds ago`;
    } else if (diffMins < 60) {
      return `${diffMins} minutes ago`;
    } else if (diffHours < 24) {
      return `${diffHours} hours ago`;
    } else {
      return `${diffDays} days ago`;
    }
  } catch (err) {
    console.error('Error formatting relative time:', err);
    return dateString;
  }
};